import { FC } from "react";
import { Title, WeatherDayArrowWrapper, WeatherDayTitleWrapper } from "./style";
import { ArrowToLeftIcon } from "shared/ui/icons";
import { useNavigate } from "react-router-dom";

export type WeatherDayTitleProps = {
  date: string | undefined;
};

export const WeatherDayTitle: FC<WeatherDayTitleProps> = ({ date }) => {
  const navigate = useNavigate();

  return (
    <WeatherDayTitleWrapper>
      <WeatherDayArrowWrapper onClick={() => navigate("/weather")}>
        <ArrowToLeftIcon />
      </WeatherDayArrowWrapper>
      {date && <Title>Погода на {date?.toLocaleLowerCase()}</Title>}
    </WeatherDayTitleWrapper>
  );
};
